module.exports = __webpack_public_path__ + "img/clothes-hanger.0ea96b14.png";